import React, {ReactElement} from 'react';
import IconWrapper, {IconProps} from '../IconWrapper';

export function CloudIcon(props: IconProps): ReactElement {
  return (
    <IconWrapper {...props}>
      <path
        d="M12.287 9.94769H4.04479C1.81418 9.94769 0 8.10286 0 5.8356C0 4.72938 0.407299 3.69903 1.14724 2.9326C1.90045 2.15268 2.92907 1.72351 4.04479 1.72351C8.45456 1.72351 11.6897 8.64838 11.8258 8.94349L12.287 9.94769ZM4.04479 3.13412C2.52924 3.13412 1.38697 4.29599 1.38697 5.8356C1.38697 7.32546 2.57901 8.53708 4.04479 8.53708H10.0481C9.70052 7.91399 9.19285 7.07505 8.56406 6.24538C7.48899 4.82634 5.83242 3.13412 4.04479 3.13412Z"
        fill="#202020"
      />
      <path
        d="M12.827 3.2784C12.1011 1.35178 10.2745 0.0507812 8.20316 0.0507812C7.30727 0.0507812 6.46778 0.294454 5.74194 0.718564C6.34418 0.905745 6.91573 1.18483 7.45492 1.52715C7.69631 1.47403 7.946 1.44452 8.20316 1.44452C9.84148 1.44452 11.221 2.58279 11.6731 4.18058C11.7345 4.38715 11.7851 4.74887 11.7851 4.74887C11.7851 4.74887 12.2927 4.6713 12.7498 4.6713C13.7859 4.6713 14.6295 5.52795 14.6295 6.5819C14.6295 7.55153 13.9145 8.35338 12.992 8.47479L13.4226 9.4107L13.5893 9.77241C14.9763 9.39552 16.0007 8.10886 16.0007 6.5819C15.9999 4.78681 14.5839 3.32055 12.827 3.2784Z"
        fill="#202020"
      />
    </IconWrapper>
  );
}
